export class MemberService {
  static $inject = ['$http', 'Activity'];

  constructor(
    private $http,
    private Activity,
  ) { }

  me() {
    return this.$http.get('/api/members/me').then((res) => res.data);
  }

  changePassword(oldPassword, newPassword) {
    return this.$http
      .put('/api/members/me/change-password', { oldPassword, newPassword })
      .then((res) => res.data);
  }

  get(memberId) {
    return this.$http.get(`/api/members/${memberId}`).then((res) => res.data);
  }

  getActivities(memberId) {
    return this.$http
      .get(`/api/members/${memberId}/activities`)
      .then((res) => {
        const activities = res.data;
        return activities.map((activity) => this.Activity.create(activity));
      });
  }

  getComments(memberId, filter) {
    return this.$http
      .get(`/api/members/${memberId}/comments?filter=${filter}`)
      .then((res) => res.data.slice(0, 10));
  }
}
